import React from 'react'
import inputComponents from './inputs/inputComponents'
import { checkPermission, checkTextTranslation, checkTranslation, getObject, setObject, translate } from '../utils/useful'
import TableRow from './partials/TableRow';
import TableHead from './partials/TableHead';
import ReactDOM from 'react-dom'
import DraggableList from './dragLibrary/DraggableList';
import { getBoundingClientRect } from '../utils/functions';
import { detectBrowser } from '../utils/useful'
import Loader from 'react-loader-spinner'
import Modal from './Modal';

class TableViewer extends React.Component {
    state = {
        errors: {},
        data: {},
        width: window.innerWidth
    }
    headerIsScrolling = false
    scrollTrigger = null

    componentDidMount() {
        this.init()
        window.addEventListener('resize', this.setWidth);

        this.setState({ broswer: detectBrowser() })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setWidth)
        // if (this.table) {
        //     this.table.removeEventListener('scroll', this.tableScroll);
        // }
    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.headers)
        if ((this.props.data != prevProps.data) || (this.props.headers !== prevProps.headers)) {
            // console.log("INIT")
            this.init()
        }
    }




    init = () => {
        // console.log(this.props.data)
        if (Array.isArray(this.props.headers)) {
            let cellWidths = this.calcCellWidths()
            // console.log(cellWidths)
            let headers = this.prepareHeader()
            this.setState({ data: this.props.data, cellWidths, show: true, headers }, () => {
                this.setWidth()
            })
        }
    }


    prepareHeader() {
        return this.props.headers
    }


    calcCellWidths() {
        let cellWidths = {}
        // TODO: CONSIDER SETTINGS
        // console.log(this.props.headers)
        cellWidths['*'] = 0
        let baseWidth = 120
        let actionsWidth = 120

        let numberOfHeader = 0

        this.props.headers.forEach(header => {
            if (header.showMain == true) {
                numberOfHeader++
            }
        });

        // console.log(numberOfHeader)
        if (this.tableContainer) {
            let tableWidth = getBoundingClientRect(this.tableContainer).width
            tableWidth = tableWidth - actionsWidth
            if (this.props.headers?.length * baseWidth < tableWidth) {
                baseWidth = (tableWidth - actionsWidth) / numberOfHeader
            }

        }

        this.props.headers.forEach(header => {
            if (header.showMain != false) {
                cellWidths[header.key] = baseWidth // TODO: CHANGE BY TYPE
                cellWidths['*'] += baseWidth
            }
        });
        cellWidths['*actions'] = actionsWidth // TODO: CHANGE BY TYPE
        cellWidths['*'] = cellWidths['*'] + actionsWidth + 30 // TODO: CHANGE BY TYPE


        // cellWidths['*'] = cellWidths['*'] + 150

        return cellWidths

    }




    setWidth = () => {
        if (this.tableContainer) {
            // console.log(this.table)
            this.setState({ width: this.tableContainer.getBoundingClientRect().width }, () => {
                this.changeWidth()
            })
        }
    }




    tableColBuilder(col) {
        let finalCol = 'col-12'

        if (600 < this.state.width && col) {
            finalCol = 'col-' + col
        }

        return finalCol
    }




    updateData = (data, cb) => {
        // console.log(data)
        this.setState({ data }, () => {
            if (cb) {
                cb()
            }
            if (this.props.updateData) {
                this.props.updateData(data)
            }
        })
    }


    changeWidth = (key, width) => {
        // console.log("CHANGE WIDTH")
        let cellWidths = this.state.cellWidths
        cellWidths[key] = width

        cellWidths['*'] = 30
        for (const [key, value] of Object.entries(cellWidths)) {
            if (value) {
                cellWidths['*'] += value
            }
        }

        if (cellWidths['*'] < this.state.width) {
            cellWidths['*'] = this.state.width
        }
        // console.log(cellWidths)
        this.setState({ cellWidths })
    }


    tableScroll = (e, ref) => {
        // console.log("Scroll Left: " + e.target.scrollLeft)
        // console.log("scrollWidth: " + e.target.scrollWidth)
        // console.log("clientWidth: " + e.target.clientWidth)
        // console.log("HERE")
        // console.log(ref)


        let scrollLeft = e.target.scrollLeft
        // console.log(e.timeStamp)
        // if (!this.lastTrigger || this.lastTrigger == 'table') {
        this.syncronizer('table', scrollLeft, e.timeStamp)
        // }

        // this.table.scrollTo(scrollLeft, 0)
        // this.header.scrollTo(scrollLeft, 0)

        // if (Math.abs(scrollLeft) > 10) {
        //     scrollLeft = Math.abs(scrollLeft - 5)
        // }
        // console.log(scrollLeft)
        // scrollLeft = Math.min(0, scrollLeft/3 - 60);
        // this.setState({ scrollX: scrollLeft })
        // if (!this.headerIsScrolling) {
        // }
        // this.tableIsScrolling = true

        // console.log("!!!!!")

        // console.log(this.scrollTrigger)

        // if (!this.scrollTrigger) {
        //     this.scrollTrigger = 'table'
        // }

        // console.log("!!!#")
        // console.log(this.scrollTrigger)

        // if (this.scrollTrigger != 'header') {
        //     this.header.scrollTo(scrollLeft, 0)
        // }

        // console.log(this.scrollTrigger)

        // if (this.scrollTrigger != "indicator") {

        // }

        // if(this.scrollTrigger == 'table') {
        //     this.scrollTrigger = null
        // }



        // this.scrollTrigger = null


        // scrollIndicator < 0 ? (-1 * scrollIndicator) + '%' 
        // scrollIndicator > 0 ? scrollIndicator + '%' 
    }

    headerScroll = (e) => {

        // e.preventDefault()
        // console.log("###")
        // console.log(this.scrollTrigger)
        // console.log(e.timeStamp)
        // console.log(this.lastTrigger)
        let scrollLeft = e.target.scrollLeft
        // if (!this.lastTrigger || this.lastTrigger == 'header') {
        // if (this.lastTriggerTime < e.timeStamp - 1000) {
        this.syncronizer('header', scrollLeft, e.timeStamp)
        // }
        // }

        // for(const [key,value] of Object.entries(e)){
        //     console.log(value)
        // }

        // if(this.table.scrollLeft != scrollLeft){
        //     console.log("#########")
        // }

        // this.setState({ scrollX: scrollLeft })
        // this.table.scrollTo(scrollLeft, 0)
        // this.headerIsScrolling = true
        // if (!this.scrollTrigger) {
        //     // console.log("SET HEADER")
        //     this.scrollTrigger = 'header'
        // }

        // if (this.scrollTrigger == 'header') {
        //     // console.log("SCROLL TABLE")
        //     this.table.scrollTo(scrollLeft, 0)
        // } else {
        //     this.scrollTrigger = null
        // }

    }



    scrollMouseDown = (e) => {

        this.initWidth = getBoundingClientRect(this.scrollIndicator).width
        this.initLeft = getBoundingClientRect(this.scrollIndicator).left
        this.tableInitLeft = getBoundingClientRect(this.table).left

        this.initX = e.clientX
        // console.log
        // this.setState({ selectedKey: key, initX: e.clientX })
        // document.body.
        document.body.classList.add("no-user-select")

        window.addEventListener("mousemove", this.scollMouseMove)
        window.addEventListener("mouseup", this.scollMouseUp)

    }

    scollMouseMove = (e) => {

        let x = e.clientX
        let dx = x - this.initX
        // if (Math.abs(this.initX - this.initLeft) < 20) {
        //     dx = dx * -1
        // }
        // console.log(dx)
        // let scrollX = (this.state.scrollX ?? 0) + dx

        // if (scrollX < 0) {
        //     scrollX = 0
        // }
        // if (scrollX > (this.state.cellWidths['*'] - this.state.width)) {
        //     scrollX = this.state.cellWidths['*'] - this.state.width
        // }
        // console.log(x)
        // console.log(this.initX)

        // console.log(dx)


        let scrollIndicator = (this.initLeft - this.tableInitLeft) + dx//scrollX * 100

        if ((scrollIndicator + this.initWidth) > this.state.width) {
            scrollIndicator = this.state.width - this.initWidth
        }

        if (scrollIndicator <= 0) {
            scrollIndicator = 0//this.state.width - this.initWidth
        }


        let scrollChange = (this.state.cellWidths['*'] / this.state.width) * scrollIndicator

        this.syncronizer('indicator', scrollChange)

        // this.scrollTheIndicator(scrollChange)
        // console.log(scrollChange)
        // if (!this.scrollTrigger) {
        //     this.scrollTrigger = 'indicator'
        //     console.log("SCROLL BY INDICATOR")
        // this.table.scrollTo(scrollChange, 0)
        // } else {
        //     this.scrollTrigger = null
        // }

        // let isRTL = false
        // if (document.body.classList.contains('rtl')) {
        //     isRTL = true
        // }

        // this.scrollIndicator.style.transition = 'none'
        // if (this.scrollIndicator) {
        //     if (!isRTL) {
        //         this.scrollIndicator.style.marginLeft = scrollIndicator + 'px'
        //         this.scrollIndicator.style.marginRight = 'auto'

        //     }
        //     else {
        //         this.scrollIndicator.style.marginRight = (-1 * scrollIndicator) + 'px'
        //         this.scrollIndicator.style.marginLeft = 'auto'
        //     }

        // }



        // console.log(scrollX)

        // console.log(scrollX)
        // this.setState({ scrollX })
        // this.scrollTrigger = 'indicator'
        // this.table.scrollTo(scrollX, 0)

        // if (newWidth >= 100) {
        // this.props.changeWidth(scrollX)
        // }

    }



    lastTrigger = null
    lastTriggerTime = null

    syncronizer(trigger, scrollLeft, timeStamp) {
        if (!this.lastTrigger) {
            // console.log("SET TRIGGER")
            this.lastTrigger = trigger
            this.lastTriggerTime = timeStamp
            //new Date().getTime()
        } else {
            if (this.lastTrigger != trigger) {
                // console.log(timeStamp)
                // console.log(this.lastTriggerTime - 100)

                if (timeStamp && timeStamp > this.lastTriggerTime + 100) {
                    this.lastTrigger = trigger
                    this.lastTriggerTime = timeStamp
                } else {
                    if (!timeStamp) {
                        this.lastTrigger = trigger
                    }
                }

            } else {
                this.lastTriggerTime = timeStamp
            }
            // if (this.lastTriggerTime && (this.lastTriggerTime < (new Date().getTime() - 1000))) {
            //     this.lastTrigger = trigger
            //     this.lastTriggerTime = new Date().getTime()
            //     console.log("NEW SET *******")
            // }
        }

        // this.lastTriggerTime = timeStamp

        // console.log(this.lastTrigger)

        if (this.lastTrigger != 'header') {
            this.header.scrollTo(scrollLeft, 0)
            // this.header.scrollLeft = scrollLeft
        }

        if (this.lastTrigger != 'table') {
            this.table.scrollTo(scrollLeft, 0)
            // this.header.offsetLeft = scrollLeft
        }
        // if (trigger == this.lastTrigger) {
        this.scrollTheIndicator(trigger, scrollLeft)
        // }

        // this.lastTrigger = null
    }



    scrollTheIndicator = (trigger, scrollLeft) => {


        let scrollIndicator = scrollLeft / this.state.cellWidths['*'] * 100

        let isRTL = false
        if (document.body.classList.contains('rtl')) {
            isRTL = true
        }

        if (this.scrollIndicator) {
            this.scrollIndicator.style.transition = 'none'
            if (!isRTL) {
                this.scrollIndicator.style.marginLeft = scrollIndicator + '%'
                this.scrollIndicator.style.marginRight = 'auto'

            }
            else {
                this.scrollIndicator.style.marginRight = (-1 * scrollIndicator) + '%'
                this.scrollIndicator.style.marginLeft = 'auto'
            }
        }
    }


    scollMouseUp = (e) => {
        document.body.classList.remove("no-user-select")
        this.lastTrigger = null

        window.removeEventListener("mousemove", this.scollMouseMove)
        window.removeEventListener("mouseup", this.scollMouseUp)
    }


    openActionsModal = (rowData, index) => {
        // console.log("OPEN")
        this.selectedRowData = rowData
        this.selectedRowIndex = index

        this.actionsModal.showModal()
    }


    openRow = (rowData, index) => {
        // console.log("OPEN")
        this.selectedRowData = rowData
        this.selectedRowIndex = index

        if (typeof this.props.actions.edit.function == 'function') {
            this.props.actions.edit.function(this.selectedRowData, this.selectedRowIndex)
        } else {
            if (this.props[this.props.actions.edit.function]) {
                this.props[this.props.actions.edit.function](this.selectedRowData, this.selectedRowIndex, this.props.actions.edit)
            } else {
                this.props.functionsHandler(this.selectedRowData, this.selectedRowIndex, this.props.actions.edit)
            }
            // console.log(this.props.actions.edit)   
        }
        // this.actionsModal.showModal()
    }




    actionClicked = (prop, index) => {
        if (typeof prop.function == 'function') {
            prop.function(this.selectedRowData, this.selectedRowIndex)
        } else {
            // console.log(this.props[prop.function])
            if (this.props[prop.function]) {
                this.props[prop.function](this.selectedRowData, this.selectedRowIndex, prop)

            } else {
                this.props.functionsHandler(this.selectedRowData, this.selectedRowIndex, prop)
            }
        }

        this.actionsModal.hideModal()
    }

    render() {
        // var shadowElement = this.state.shadowElement
        if (this.state.show) {
            // console.log(this.state.cellWidths['*'])
            // console.log(this.state.width)
            // console.log(this.state.width / this.state.cellWidths['*'])
            // let scrollIndicator = this.state.scrollX / this.state.cellWidths['*'] * 100
            // console.log(scrollIndicator)

            let RowContainerComponent = "div"
            if (this.props.settings?.isSortable) {
                RowContainerComponent = DraggableList
            }

            return (
                <section ref={el => this.tableContainer = el} className={"w-100 table defaultTable  pb-3 " + (this.state.broswer)}  >

                    {/* <section ref={el => this.tableContainer = el} className={" table defaultTable  pb-3 " + (this.state.broswer)}  > */}

                    <div onScrollCapture={(e) => this.headerScroll(e)} ref={el => this.header = el} className="text-center w-100 no-scrollbar" style={{ overflow: 'auto', zIndex: 4, position: 'sticky', top: this.props.top ?? 47 }}>
                        {/* <div style={{}}> */}
                        <TableHead headers={this.props.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} actions={this.props.actions} settings={this.props.settings} />

                        {/* </div> */}
                    </div>

                    {this.props.isLoading && (
                        <div className="flexcc mt-4 mb-3">
                            <Loader
                                type={"ThreeDots"}
                                color={"#789"}
                                height={20}
                                width={50}
                            />
                        </div>
                    )}

                    {!this.props.isLoading && this.state.data?.length == 0 && (
                        <div className="flexcc mt-4 mb-3 w-100">
                            <p className="description-text text-small">{translate('foundNothing').toUpperCase()}</p>
                        </div>
                    )}


                    <div onScroll={(e) => { this.scrollTrigger = 'table'; this.tableScroll(e) }} ref={el => this.table = el} className="w-100 h-100 no-scrollbar test" style={{ overflow: 'auto' }}>


                        {/* <div ref={el => this.header = el} className="text-center w-100 no-scrollbar" style={{ overflow: 'auto', zIndex: 4, position: 'sticky', top: 47 }}>
                            <div style={{}}>
                                <TableHead headers={this.props.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} />

                            </div>
                        </div> */}
                        {/* <TableHead headers={this.props.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} scrollX={this.state.scrollX} /> */}
                        <div className="tableBody " style={{ width: this.state.cellWidths['*'] }} >


                            {/* <RowContainerComponent dragStarted={this.dragStarted} dragOver={this.dragOver} data={this.state.data} updateData={this.updateData} width={this.state.width}> */}
                            <RowContainerComponent dragstarted={this.dragStarted} dragover={this.dragOver} data={this.state.data} updatedata={RowContainerComponent != 'div' ? this.updateData : null} width={this.state.width}>


                                {this.state.data && this.state.data.map((prop, index) => {
                                    return (
                                        <TableRow
                                            ref={el => this[prop.id] = el}
                                            index={index}
                                            data={prop}
                                            page={this.props.page}
                                            headers={this.props.headers}
                                            key={prop?._id ?? prop?.id}
                                            id={prop?._id ?? prop?.id}
                                            widths={this.state.cellWidths}
                                            scrollX={this.state.scrollX}
                                            actions={this.props.actions}
                                            settings={this.props.settings}
                                            openActionsModal={this.openActionsModal}
                                            openRow={this.openRow}
                                        />
                                    )
                                })}
                            </RowContainerComponent>

                        </div>

                    </div>
                    {/* <div className="text-center p-2" style={{ backgroundColor: '#0d9488', position: 'sticky', bottom: 10 }}>
                        <TableHead headers={this.state.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} scrollX={this.state.scrollX} />
                    </div> */}

                    {this.state.cellWidths['*'] > this.state.width && (
                        <div className="tableScroll blur-back" >

                            <div ref={el => this.scrollIndicator = el} className="scrollIndicator" onMouseDown={e => this.scrollMouseDown(e)} style={{ width: (this.state.width / this.state.cellWidths['*']) * 100 + '%', }}>

                            </div>
                        </div>
                    )}

                    <Modal ref={el => this.actionsModal = el} maxWidth={300}>
                        <div className="modal-body py-4 px-4 text-center " style={{ borderRadius: 12 }}>
                            <p className="text-bold text-uppercase mb-3">{translate("Choose Action")}</p>
                            {/* <p className="text-smaller  mb-3 text-description">{translate("List of available actions")}</p> */}

                            {this.props.actions && Object.values(this.props.actions).map((prop, index) => {
                                if (checkPermission(this.props.variables?.permissionRoot + '.' + prop.permission)) {
                                    let onlyView = false
                                    if(prop.key == 'edit'){
                                        if(!checkPermission(this.props.variables?.permissionRoot + '.' + 'edit')){
                                            onlyView= true
                                        }
                                    }
                                    return (
                                        <div key={index} className="mb-1 w-100">
                                            <button onClick={() => this.actionClicked(prop, index)} className="w-100" style={{ backgroundColor: prop.color ? prop.color : '#007aff15', borderRadius: 8, padding: '10px 20px' }}>
                                                <p className="text-bold text-uppercase text-normal" style={{ color: '#fff' }}>{onlyView ? 'View':checkTranslation(prop.label)}</p>
                                            </button>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    </Modal>
                </section>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default TableViewer;